import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import {
  BadRequestError,
  Forbidden,
  UnProcessableEntity,
  UnexpectedError,
} from 'domain/errors';
import { GetFilteredOrgs } from 'domain/usecases/org/remote';
import 'infra/global/variables';

export class RemoteGetFilteredOrgs implements GetFilteredOrgs {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetFilteredOrgs.Model>;

  constructor(url: string, httClient: HttpClient<GetFilteredOrgs.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (
    params: GetFilteredOrgs.Params,
  ): Promise<GetFilteredOrgs.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.unprocessableEntity:
        throw new UnProcessableEntity();
      default:
        throw new UnexpectedError();
    }
  };
}
